/**
 * ! This file was generated by swagger-typescript-api. Do not change the file directly.
 */

/** @format int32 */
export enum ModelsCustomValueType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5
}

/** @format int32 */
export enum TypesContextOrigin {
  Value1 = 1,
  Value2 = 2
}

/** @format int32 */
export enum GetTransparencyTimelineStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2
}

export interface RevenuesAddRevenueInBulkItemRequest {
  /** @minLength 1 */
  user_document?: string
  /** @format int64 */
  current_amount?: number
}

export interface RevenuesAddRevenueInBulkRequest {
  /**
   * @maxItems 25000
   * @minItems 1
   */
  items: RevenuesAddRevenueInBulkItemRequest[]
}

export interface CommonQuestionAnswerRequest {
  /** @minLength 1 */
  question_id?: string
  /** @minItems 1 */
  selected_option_ids?: string[]
  /**
   * @minLength 3
   * @maxLength 255
   */
  custom_text_answer?: string | null
}

export interface CommonSubmitSurveyAnswerRequest {
  /** @minLength 1 */
  survey_id?: string
  /**
   * @minLength 10
   * @maxLength 150
   */
  survey_key?: string
  /** @minItems 1 */
  question_answers?: CommonQuestionAnswerRequest[]
}

export interface RevenuesDeleteRevenueDocumentationRequest {
  /**
   * @minLength 1
   * @maxLength 50
   */
  file_id?: string
}

export interface RevenuesUpdateCurrentAmountRevenueRequest {
  amount?: string | null
}

export interface CreditHomeGetExclusiveContentSectionResponse {
  elements?: any[] | null
}

export interface CreditHomeGetImproveOpportunitiesSectionResponse {
  elements?: any[] | null
}

export interface WebViewUrlGetWebViewUrlResponse {
  web_view_url?: string | null
}

export interface SendInterestGuaranteeReceivablesCreditCardSendInterestResponse {
  id?: string | null
}

export type AddInBulkAddRevenueInBulkResponse = object

export interface DocumentationAbandonDocumentationAbandonResponse {
  documentation_session_id?: string | null
  /** @format int32 */
  total_files?: number
}

export interface DocumentationConfirmDocumentationConfirmResponse {
  documentation_session_id?: string | null
}

export interface DocumentationDeleteDocumentationDeleteResponse {
  file_id?: string | null
}

export interface DocumentationStartSessionRevenueResponse {
  page_title?: string | null
  page_subtitle?: string | null
  valid_documents?: StartSessionValidDocumentsResponse
  upload?: StartSessionUploadResponse
  actions?: StartSessionActionsResponse[] | null
}

export interface StartSessionActionsResponse {
  name?: string | null
  text?: string | null
  icon?: string | null
  is_available?: boolean
}

export interface StartSessionUploadResponse {
  extensions?: string[] | null
  /** @format int64 */
  max_size_bytes?: number
  max_size_description?: string | null
  /** @format int32 */
  max_files_allowed?: number
  actions?: StartSessionActionsResponse[] | null
}

export interface StartSessionValidDocumentsResponse {
  title?: string | null
  subtitle?: string | null
  types?: ModelsEnumValue[] | null
  actions?: StartSessionActionsResponse[] | null
}

export interface DocumentationUploadDocumentationUploadResponse {
  file_id?: string | null
}

export interface UpdateCurrentAmountUpdateCurrentAmountRevenueResponse {
  id?: string | null
  skip_upload_documents?: boolean
}

export interface GetRevenueDetailsActionResponse {
  name?: string | null
  text?: string | null
  icon?: string | null
  is_available?: boolean
  variant?: string | null
  redirection?: ValueObjectsRedirection
}

export interface GetRevenueDetailsDocumentationResponse {
  title?: string | null
  icon?: string | null
  tag_text?: string | null
  tag_variant?: string | null
  is_available?: boolean
  actions?: GetRevenueDetailsActionResponse[] | null
}

export interface GetRevenueDetailsOpenFinanceResponse {
  title?: string | null
  subtitle?: string | null
  divisor_title?: string | null
  image_url?: string | null
  actions?: GetRevenueDetailsActionResponse[] | null
}

export interface GetRevenueDetailsPageTitleResponse {
  title?: string | null
  subtitle?: string | null
}

export interface GetRevenueDetailsPendingResponse {
  title?: string | null
  subtitle?: string | null
  description?: string | null
  question?: string | null
  actions?: GetRevenueDetailsActionResponse[] | null
}

export interface GetRevenueDetailsResponse {
  sections?: GetRevenueDetailsSectionsResponse
}

export interface GetRevenueDetailsSectionsResponse {
  page_title?: GetRevenueDetailsPageTitleResponse
  revenue_pending?: GetRevenueDetailsPendingResponse
  revenue_updated?: GetRevenueDetailsUpdatedResponse
  documentation?: GetRevenueDetailsDocumentationResponse
  open_finance?: GetRevenueDetailsOpenFinanceResponse
}

export interface GetRevenueDetailsStatusResponse {
  text?: string | null
  variant?: string | null
}

export interface GetRevenueDetailsUpdatedResponse {
  title?: string | null
  subtitle?: string | null
  description?: string | null
  status?: GetRevenueDetailsStatusResponse
}

export interface CloseCloseSurveyCommandResponse {
  survey_id?: string | null
  survey_key?: string | null
  interaction_id?: string | null
}

export interface SubmitAnswerSubmitSurveyAnswerCommandResponse {
  survey_id?: string | null
  survey_key?: string | null
  interaction_id?: string | null
  answer_id?: string | null
}

export interface CheckDisplaySurveyEligibilityResponse {
  should_display_survey?: boolean
  survey_details?: SurveyDetailsResponse
}

export interface OptionResponse {
  id?: string | null
  text?: string | null
  is_custom_text_option?: boolean | null
}

export interface QuestionResponse {
  id?: string | null
  title?: string | null
  description?: string | null
  question_type?: string | null
  component_type?: string | null
  allow_custom_text?: boolean
  /** @format int32 */
  order?: number
  options?: OptionResponse[] | null
}

export interface SurveyDetailsResponse {
  survey_id?: string | null
  survey_key?: string | null
  title?: string | null
  description?: string | null
  questions?: QuestionResponse[] | null
}

export interface GetTriggersSurveyTriggerResponse {
  survey_id?: string | null
  survey_key?: string | null
  events_name?: string[] | null
}

export interface GetTransparencyActionResponse {
  name: string | null
  is_available?: boolean
  tooltip?: string | null
  redirection?: ValueObjectsRedirection
}

export interface GetTransparencyKycResponse {
  status: ModelsCustomValue
  timeline?: GetTransparencyTimelineResponse[] | null
}

export interface GetTransparencyOfferResponse {
  title: string | null
  value_mask?: string | null
  value: ModelsCustomValue
}

export interface GetTransparencyResponse {
  kyc?: GetTransparencyKycResponse
  offer?: GetTransparencyOfferResponse
  redirection?: ValueObjectsRedirection
  actions?: GetTransparencyActionResponse[] | null
}

export interface GetTransparencyTimelineResponse {
  /** @format int32 */
  order: number
  title: string | null
  subtitle: string | null
  status: GetTransparencyTimelineStatus
}

export interface CommonCustomErrorResponse {
  errors?: CommonErrorResponse[] | null
  type?: string | null
  metadata?: Record<string, string | null>
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseCreditHomeGetExclusiveContentSectionResponse {
  content?: CreditHomeGetExclusiveContentSectionResponse
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseCreditHomeGetImproveOpportunitiesSectionResponse {
  content?: CreditHomeGetImproveOpportunitiesSectionResponse
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseWebViewUrlGetWebViewUrlResponse {
  content?: WebViewUrlGetWebViewUrlResponse
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseSendInterestGuaranteeReceivablesCreditCardSendInterestResponse {
  content?: SendInterestGuaranteeReceivablesCreditCardSendInterestResponse
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseAddInBulkAddRevenueInBulkResponse {
  content?: AddInBulkAddRevenueInBulkResponse
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseDocumentationAbandonDocumentationAbandonResponse {
  content?: DocumentationAbandonDocumentationAbandonResponse
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseDocumentationConfirmDocumentationConfirmResponse {
  content?: DocumentationConfirmDocumentationConfirmResponse
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseDocumentationDeleteDocumentationDeleteResponse {
  content?: DocumentationDeleteDocumentationDeleteResponse
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseDocumentationStartSessionRevenueResponse {
  content?: DocumentationStartSessionRevenueResponse
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseDocumentationUploadDocumentationUploadResponse {
  content?: DocumentationUploadDocumentationUploadResponse
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseUpdateCurrentAmountUpdateCurrentAmountRevenueResponse {
  content?: UpdateCurrentAmountUpdateCurrentAmountRevenueResponse
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseGetRevenueDetailsResponse {
  content?: GetRevenueDetailsResponse
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseCloseCloseSurveyCommandResponse {
  content?: CloseCloseSurveyCommandResponse
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseSubmitAnswerSubmitSurveyAnswerCommandResponse {
  content?: SubmitAnswerSubmitSurveyAnswerCommandResponse
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseCheckDisplaySurveyEligibilityResponse {
  content?: CheckDisplaySurveyEligibilityResponse
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseGetTriggersSurveyTriggerResponse {
  content?: GetTriggersSurveyTriggerResponse[] | null
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonCustomResponseGetTransparencyResponse {
  content?: GetTransparencyResponse
  trace_key?: string | null
  is_valid?: boolean
}

export interface CommonErrorResponse {
  type?: string | null
  description?: string | null
}

export interface ValueObjectsRedirection {
  is_available?: boolean
  url?: string | null
  url_type?: string | null
}

export interface ModelsCustomValue {
  description?: string | null
  value?: any
  type?: ModelsCustomValueType
}

export interface ModelsEnumValue {
  description?: string | null
  value?: any
  type?: ModelsCustomValueType
}

export interface ProblemDetails {
  type?: string | null
  title?: string | null
  status?: string | null
  detail?: string | null
  instance?: string | null
  [key: string]: any
}

export interface WebV1RevenueListParams {
  redirection_origin: string
}

export type WebV1RevenueListData = CommonCustomResponseGetRevenueDetailsResponse

export type WebV1RevenuePartialUpdateData = CommonCustomResponseUpdateCurrentAmountUpdateCurrentAmountRevenueResponse

export type WebV1RevenueAbandonDocumentationDeleteData =
  CommonCustomResponseDocumentationAbandonDocumentationAbandonResponse

export type WebV1RevenueConfirmDocumentationPartialUpdateData =
  CommonCustomResponseDocumentationConfirmDocumentationConfirmResponse

export type WebV1RevenueFileDocumentationDeleteData = CommonCustomResponseDocumentationDeleteDocumentationDeleteResponse

export type WebV1RevenueStartDocumentationCreateData = CommonCustomResponseDocumentationStartSessionRevenueResponse

export type WebV1RevenueUploadDocumentationCreateData =
  CommonCustomResponseDocumentationUploadDocumentationUploadResponse

export type WebV1SurveysCreateData = CommonCustomResponseSubmitAnswerSubmitSurveyAnswerCommandResponse

export type WebV1SurveysCheckDisplayListData = CommonCustomResponseCheckDisplaySurveyEligibilityResponse

export type WebV1SurveysCloseCreateData = CommonCustomResponseCloseCloseSurveyCommandResponse

export type WebV1SurveysTriggersListData = CommonCustomResponseGetTriggersSurveyTriggerResponse

export type WebV1TransparencyListData = CommonCustomResponseGetTransparencyResponse
